var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgROrdenes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.18 31.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2{fill:#464646}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Ordenes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__base-75",
    fill: "none",
    d: "M0 0h31.18v31.18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Grupo_5475",
    "data-name": "Grupo 5475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Grupo_5474",
    "data-name": "Grupo 5474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3521",
    "data-name": "Trazado 3521",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M24.59 29.12h-18a3.47 3.47 0 01-3.47-3.47V5.52A3.49 3.49 0 016.59 2h18a3.49 3.49 0 013.47 3.49v20.16a3.47 3.47 0 01-3.46 3.47zm-18-26.24A2.64 2.64 0 004 5.53v20.13a2.62 2.62 0 002.62 2.62h18a2.44 2.44 0 001.85-.77 2.55 2.55 0 00.77-1.85V5.52a2.65 2.65 0 00-2.62-2.65z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3522",
    "data-name": "Trazado 3522",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M23.57 8.47H10.74a.45.45 0 100 .9h12.83a.45.45 0 000-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3523",
    "data-name": "Trazado 3523",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M23.57 17.7H10.74a.46.46 0 100 .91h12.83a.46.46 0 000-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3524",
    "data-name": "Trazado 3524",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M23.57 13.08H10.74a.47.47 0 00-.46.46.46.46 0 00.46.45h12.83a.45.45 0 00.45-.45.46.46 0 00-.45-.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3525",
    "data-name": "Trazado 3525",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M23.57 22.32H10.74a.46.46 0 00-.46.45.47.47 0 00.46.46h12.83a.46.46 0 00.45-.46.45.45 0 00-.45-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3526",
    "data-name": "Trazado 3526",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M8.54 8.47h-.89a.45.45 0 000 .9h.88a.45.45 0 100-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3527",
    "data-name": "Trazado 3527",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M8.54 17.7h-.89a.46.46 0 000 .91h.88a.46.46 0 100-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3528",
    "data-name": "Trazado 3528",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M8.54 13.08h-.89a.46.46 0 00-.45.46.45.45 0 00.45.45h.88a.46.46 0 00.47-.45.47.47 0 00-.46-.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__Trazado_3529",
    "data-name": "Trazado 3529",
    className: "R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__R-Ordenes_svg__cls-2",
    d: "M8.54 22.32h-.89a.45.45 0 00-.45.45.46.46 0 00.45.46h.88a.47.47 0 00.47-.46.46.46 0 00-.46-.45z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgROrdenes);
export default __webpack_public_path__ + "static/media/R-Ordenes.133adad3.svg";
export { ForwardRef as ReactComponent };